import { ApolloClient } from 'apollo-client';
import React from 'react';

import { Data as MoveUnitsInventoryCasepacksData } from './queries/moveUnitsInventoryPackages';
import { Data as MoveUnitsInventoryProductsData } from './queries/moveUnitsInventoryProducts';
import { Data as MoveUnitsOffersData } from './queries/moveUnitsOffers';

export type ProductsData =
  | MoveUnitsInventoryProductsData
  | MoveUnitsInventoryCasepacksData;

export type OffersData = MoveUnitsOffersData;

export enum ProductType {
  Item = 'item',
  Casepack = 'casepack',
}

export enum PackageType {
  SingleItem = 'single-item',
  MultiItem = 'multi-item',
}

export enum BulkCspkTypes {
  SingleItems = 'single-items',
  MultiItems = 'multi-items',
  SingleAndMultiItems = 'single-and-multi',
}

export type ClientProps = {
  client: ApolloClient<any>;
};

export type EnhancedProps = Props & ClientProps;

export type OfferListProps = ClientProps;
export type AllocationProps = ClientProps;
export type OfferSummaryProps = ClientProps;

export type Enhance = (
  C: React.ComponentType<EnhancedProps>,
) => React.ComponentType<Props>;

export type QueryParams = {
  key: string;
  groupUUID: string;
  type: ProductType;
  sortDirection: string;
  sortKey: string;
  initialMarketID: string;
  index?: string;
  limit?: string;
  sortScope?: string;
  sortScopeValue?: string;
};

export type Props = {
  isBulkMove: boolean;
};

export enum MoveMode {
  LOOSE = 'loose',
  SINGE = 'single',
  MULTI = 'multi',
  SINGLE_AND_MULTI = 'single+multi',
}

export enum MoveType {
  QUANTITY = 'quantity',
  QUANTITY_UP_TO = 'quantity_up_to',
  PERCENTAGE = 'percentage',
  PRICE = 'price',
}

export type MoveUnitsMove = {
  destination: string;
  type: MoveType;
  mode: MoveMode;
  value: number;
};

export type EditMode = {
  isActive: boolean;
  allocatedAmount: number;
};

export type MoveUnitsPayload = {
  searchKey: string;
  uploadChannel: string;
  moves: MoveUnitsMove[];
  userId: string;
  groupId: string;
  companyUUID: string;
  productType: ProductType;
};

export enum Direction {
  None = 'none',
  Up = 'up',
  Down = 'down',
}

export enum NavigationType {
  Pagination = 'pagination',
  BackButtonOnly = 'backButtonOnly',
}

export enum ControlsDirection {
  Back = 'Back',
  Forward = 'Forward',
}

export type CountUpMetric = {
  label: string;
  value: number | string;
  initialCountAnimationValue: number | string;
  previousValue: number | string;
  savedValue: number | string;
  arrowDirection: Direction;
  noValuePlaceholder: string;
  separator: string;
  decimals: number;
  isAnimated: boolean;
  hasAlert?: boolean;
  alertLabel?: string;
};

export type CountUpMetrics = {
  [key: string]: CountUpMetric;
};

export enum ConfirmModalActions {
  DistributeModeAction = 'DistributeModeAction',
  SaveAllocation = 'SaveAllocation',
  Redirect = 'Redirect',
  ChooseOffer = 'ChooseOffer',
  SortOffers = 'SortOffers',
}

export enum AllocationToolFields {
  useQuantity = 'useQuantity',
  usePercentage = 'usePercentage',
}

export enum AllocationFieldsAnalyticType {
  quantity = 'allocation:byQty',
  percentage = 'allocation:byPercentage',
}

export enum AllocationByDistributionType {
  distributionAuto = 'allocation:distributionAuto',
  distributionManual = 'allocation:distributionManual',
}

export type SizeProp = {
  title: string;
  unitsInOffer: number;
  unallocated: number;
};

export type SizesProps = SizeProp[];
